import classNames from 'classnames'
import React from 'react'
import { LOYALTY_TIER_ITEM } from 'modules/loyalty/constants'
import getCurTierNameLoyaltySelect from 'modules/loyalty/redux/selectors/get-cur-tier-name'
import useSelector from 'hooks/use-selector'
import LoyaltyTierIcon from 'containers/LoyaltyTierIcon'
import Flex from 'components/Flex'
import './index.css'

export default function LoyaltyTierIconWithBackground (props) {
  logUtil('LoyaltyTierIconWithBackground').debug('[start] props=', props)
  const tierName = useSelector(getCurTierNameLoyaltySelect)
  const name = props.tierName || tierName

  if (!LOYALTY_TIER_ITEM[name]) {
    logUtil('LoyaltyTierIconWithBackground').debug('[noop] no tier props=', props)
    return <></>
  }

  const className = classNames({
    'loyalty-tier-icon-with-background': true,
    'loyalty-tier-icon-with-background_light': props.isLight
  })

  return (
    <Flex
      className={className}
      data-loyalty-tier-name={name}
    >
      <LoyaltyTierIcon tierName={name} />
    </Flex>
  )
}
